import getBoostNotifications from './graphql/queries/getBoostNotifications';
import getPendingNotifications from './graphql/queries/getPendingNotifications';
import getPopupNotifications from './graphql/queries/getPopupNotifications';
import onBoostTimerNotification from './graphql/subscriptions/onBoostTimerNotification';
import onKycNotificationAdded from './graphql/subscriptions/onKycNotificationAdded';
import onMyDepositChanged from './graphql/subscriptions/onMyDepositChanged';
import onMyWithdrawalChanged from './graphql/subscriptions/onMyWithdrawalChanged';
import onNftDropRewardNotificationAdded from './graphql/subscriptions/onNftDropRewardNotificationAdded';
import onNormalNotificationAdded from './graphql/subscriptions/onNormalNotificationAdded';
import onSiteNotificationAdded from './graphql/subscriptions/onSiteNotificationAdded';
import NotificationQueue from './helpers/NotificationQueue';
import createFetchFn from '@/server/helpers/worker/createFetchFn';
import getSubscriptionClient from '@/server/helpers/worker/getSubscriptionClient';

const queue = new NotificationQueue();
const addToQueue = (notif: WorkerNotification) => queue.addToQueue(notif);

type Event =
  | { type: 'init'; context: WorkerContext }
  | { type: 'add'; notification: WorkerNotification }
  | { type: 'sendNext' };

addEventListener('message', async (event: MessageEvent<Event>) => {
  switch (event.data.type) {
    case 'init':
      const { context } = event.data;
      await registerQueries(context);
      await registerSubscriptions(context);
      return queue.sendMessage();
    case 'add':
      return addToQueue(event.data.notification);
    case 'sendNext':
      return queue.sendMessage();
    default:
      return null;
  }
});

const registerQueries = async (context: WorkerContext) => {
  const fetch = createFetchFn(context);
  return Promise.all([
    getPendingNotifications({ context, fetch, addToQueue }),
    getBoostNotifications({ context, fetch, addToQueue }),
    getPopupNotifications({ context, fetch, addToQueue }),
  ]);
};

const registerSubscriptions = async (context: WorkerContext) => {
  const client = getSubscriptionClient(context);
  return Promise.all([
    onMyDepositChanged({ context, client, addToQueue }),
    onMyWithdrawalChanged({ context, client, addToQueue }),
    onNormalNotificationAdded({ context, client, addToQueue }),
    onSiteNotificationAdded({ context, client, addToQueue }),
    onBoostTimerNotification({ context, client, addToQueue }),
    onNftDropRewardNotificationAdded({ context, client, addToQueue }),
    onKycNotificationAdded({ context, client, addToQueue }),
  ]);
};
